<template>
  <div id="app" class="carrier-matrix" :style="cssVars">
    <div v-if="this.$hostname === 'https://idacmstaging.wpengine.com'"><b-alert class="my-4" show variant="danger">STAGING!</b-alert></div>
    <template v-if="form==='product'">
      <BGAProductSearch :buttonText="buttonText" :agencyId="agencyId" :apiKey="apiKey" searchType="Life Product"></BGAProductSearch>
    </template>
    <template v-if="form==='abr'">
      <BGAABRSearch :buttonText="buttonText" :agencyId="agencyId" :apiKey="apiKey" searchType="ABR"></BGAABRSearch>
    </template>
    <template v-if="form==='report'">
      <BGAReportSearch :buttonText="buttonText" :agencyId="agencyId" :apiKey="apiKey" searchType="Reports" :searchParams="searchParams" ></BGAReportSearch>
    </template>
    <template v-if="form==='contact'">
      <BGAContactSearch :buttonText="buttonText" :agencyId="agencyId" :apiKey="apiKey" searchType="Contact"></BGAContactSearch>
    </template>
    <template v-if="form==='commission'">
      <BGACommissionSearch :buttonText="buttonText" :agencyId="agencyId" :apiKey="apiKey" searchType="Commissions"></BGACommissionSearch>
    </template>
    <template v-if="results==='product'">
      <BGAProductSearchResults :resultsHeight="resultsHeight" searchType="Life Product"></BGAProductSearchResults>
    </template>
    <template v-if="results==='abr'">
      <BGAABRSearchResults :resultsHeight="resultsHeight" searchType="ABR"></BGAABRSearchResults>
    </template>
    <template v-if="results==='report'">
      <BGAReportSearchResults :resultsHeight="resultsHeight" searchType="Reports"></BGAReportSearchResults>
    </template>
    <template v-if="results==='contact'">
      <BGAContactSearchResults :resultsHeight="resultsHeight" searchType="Contact"></BGAContactSearchResults>
    </template>
    <template v-if="results==='commission'">
      <BGACommissionSearchResults :resultsHeight="resultsHeight" searchType="Commissions"></BGACommissionSearchResults>
    </template>
  </div>
</template>

<script>
import BGAProductSearch from "./components/BGAProductSearch"
import BGAABRSearch from "./components/BGAABRSearch"
import BGAReportSearch from "./components/BGAReportSearch"
import BGAContactSearch from "./components/BGAContactSearch"
import BGACommissionSearch from "./components/BGACommissionSearch"

import BGAProductSearchResults from "./components/BGAProductSearchResults"
import BGAABRSearchResults from "./components/BGAABRSearchResults"
import BGAReportSearchResults from "./components/BGAReportSearchResults"
import BGAContactSearchResults from "./components/BGAContactSearchResults"
import BGACommissionSearchResults from "./components/BGACommissionSearchResults"

export default {
  name: "App",
  props: {
    form: {type: String},
    results: {type: String},
    buttonText: {type: String, required: false, default: 'Search'},
    apiKey: {type: String},
    agencyId: {type: String},
    searchParams: {type: String, required: false, default: ''},
    resultsHeight: {type: String, required: false, default: '96vh'},
    headingColor: {type: String, required: false, default: '#6c757d'},
    headingOpenColor: {type: String, required: false, default: '#495057'},
    headingHoverColor: {type: String, required: false, default: '#343a40'},
    headingTextColor: {type: String, required: false, default: '#ffffff'},
  },
  components: {
    BGAProductSearch,
    BGAABRSearch,
    BGAReportSearch,
    BGAContactSearch,
    BGACommissionSearch,
    BGAProductSearchResults,
    BGAABRSearchResults,
    BGAReportSearchResults,
    BGAContactSearchResults,
    BGACommissionSearchResults
  },
  computed: {
    cssVars() {
      return {
        '--headingColor': this.headingColor,
        '--headingOpenColor': this.headingOpenColor,
        '--headingHoverColor': this.headingHoverColor,
        '--headingTextColor': this.headingTextColor,
      }
    }
  },
}
</script>
<style scoped lang="scss">
.carrier-matrix ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
}
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>
<style>
#app.carrier-matrix button.btn-secondary {background-color: var(--headingColor); border-color: var(--headingColor); color: var(--headingTextColor); }
#app.carrier-matrix button.btn-secondary.not-collapsed {background-color: var(--headingOpenColor); border-color: var(--headingOpenColor);}
#app.carrier-matrix button.btn-secondary:hover {background-color: var(--headingHoverColor); border-color: var(--headingHoverColor);}
.carrier-matrix .list-unstyled {margin:0;}
.carrier-matrix .word-nowrap { word-wrap: normal;}
.carrier-matrix .modal.fade {opacity: 1;}
/*.carrier-matrix td {
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  word-break: break-all;
  word-break: break-word;
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
}*/
.carrier-matrix .modal-content  {
  overflow-y: auto;
  max-height: 90vh;
}

[id^=accordion-].collapse.show {
    display: block !important;
}

</style>
